import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_SERVER_BASE_URL
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('accessToken')}`

axios.interceptors.request.use(
  config => {
    const hasExplicitYear = Object.keys(config.headers).some(header => header.toLowerCase() === 'x-year')
    if (!hasExplicitYear) config.headers['X-Year'] = localStorage.getItem('selectedYear')
    const activeCompany = JSON.parse(localStorage.getItem('activeCompany') || 'null')
    if (activeCompany && activeCompany.id) config.headers['X-Company-ID'] = activeCompany.id
    return config
  },
  error => Promise.reject(error)
)


export default axios
